import _regenerator from "C:/Users/lptni/\u5F00\u53D1/dev/project/unbox-server/vue-admin/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "C:/Users/lptni/\u5F00\u53D1/dev/project/unbox-server/vue-admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _typeof from "C:/Users/lptni/\u5F00\u53D1/dev/project/unbox-server/vue-admin/node_modules/@babel/runtime/helpers/esm/typeof.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/web.dom-collections.for-each.js";
import api from '@/api';
import util from '@/libs/util.js';
export default {
  name: 'MatchmakerOuterLinkList',
  data: function data() {
    return {
      downUrl: process.env.VUE_APP_DOWNLOAD_URL,
      uploadUrl: process.env.VUE_APP_API,
      uploadHeaders: {
        Authorization: util.cookies.get('token')
      },
      citys: [],
      selectForm: {
        selectCitys: [],
        keyword: null
      },
      pageNo: 1,
      pageSize: 10,
      tableData: [],
      pageTotal: 0,
      // 编辑弹窗
      editDialogVisible: false,
      editForm: {
        outerLinkId: null,
        wechatQrUrl: '',
        shopImages: '',
        shopAddress: ''
      },
      // 门店照片(手动维护，存相对路径 {url})
      photosList: []
    };
  },
  methods: {
    getImage: function getImage(url) {
      if (!url) return '';
      return url.indexOf('http') === 0 ? url : this.downUrl + url;
    },
    formatTime: function formatTime(val) {
      if (!val) return '';
      var str = String(val);
      return str.length >= 16 ? str.substring(0, 16) : str;
    },
    getShopImages: function getShopImages(str) {
      if (!str) return [];
      // 门店照片存储格式为 JSON 数组，如 [{"url":"a.jpg"},{"url":"b.jpg"}]
      if (str.trim().indexOf('[') === 0) {
        try {
          var arr = JSON.parse(str);
          if (Array.isArray(arr)) {
            return arr.map(function (item) {
              if (item && _typeof(item) === 'object') return item.url || '';
              return String(item);
            }).filter(Boolean);
          }
        } catch (e) {
          // 解析失败则走下方逗号分隔兼容逻辑
        }
      }
      // 兼容逗号分隔的旧格式
      return String(str).split(',').filter(Boolean);
    },
    getCityName: function getCityName(str) {
      if (!str) return '';
      try {
        var arr = JSON.parse(str);
        if (Array.isArray(arr) && arr.length > 0) return String(arr[arr.length - 1]);
        return str;
      } catch (e) {
        return String(str);
      }
    },
    tableRowClassName: function tableRowClassName(_ref) {
      var row = _ref.row;
      return row.hiddenSts === 1 ? 'gray-row' : '';
    },
    initCitys: function initCitys() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var res;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return api.GET_BYCITYOPENING_TREE_LIST({});
            case 1:
              res = _context.v;
              _this.citys = res.body;
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    // 行内修改排序
    sortChange: function sortChange(row) {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var par;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              par = {
                outerLinkId: row.outerLinkId,
                sort: row.sort
              };
              _context2.n = 1;
              return api.UPDATE_SORT_MATCHMAKEROUTERLINK(par);
            case 1:
              _this2.$message.success('操作成功');
              _this2.initTableData();
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    // 隐藏/恢复显示
    updateHidden: function updateHidden(row) {
      var _this3 = this;
      var hidden = row.hiddenSts === 1;
      var action = hidden ? '恢复' : '隐藏';
      var par = {
        outerLinkId: row.outerLinkId,
        hiddenSts: hidden ? 0 : 1
      };
      this.$confirm('此操作将' + action + '该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _context3.n = 1;
              return api.UPDATE_HIDDEN_MATCHMAKEROUTERLINK(par);
            case 1:
              _this3.$message.success('操作成功');
              _this3.initTableData();
            case 2:
              return _context3.a(2);
          }
        }, _callee3);
      }))).catch(function () {
        _this3.$message({
          type: 'info',
          message: '已取消' + action
        });
      });
    },
    // 打开编辑弹窗，回显二维码/门店照片/地址
    openEdit: function openEdit(row) {
      var _this4 = this;
      this.editForm.outerLinkId = row.outerLinkId;
      this.editForm.shopAddress = row.shopAddress || '';
      this.editForm.wechatQrUrl = row.wechatQrUrl || '';
      // 门店照片回显
      this.photosList = [];
      this.getShopImages(row.shopImages).forEach(function (item) {
        _this4.photosList.push({
          url: item
        });
      });
      this.editDialogVisible = true;
    },
    beforeAvatarUpload: function beforeAvatarUpload(file) {
      var isLt2M = file.size / 1024 / 1024 < 10;
      if (!isLt2M) {
        this.$message.error('上传文件不能超过 10MB!');
      }
      return isLt2M;
    },
    // 二维码上传成功(再次点击可直接替换为新图)
    handleQrSuccess: function handleQrSuccess(res) {
      if (res && res.body && res.body.url) {
        this.editForm.wechatQrUrl = res.body.url;
      }
    },
    removeQr: function removeQr() {
      this.editForm.wechatQrUrl = '';
    },
    // 门店照片上传成功
    handlePhotoSuccess: function handlePhotoSuccess(res) {
      if (res && res.body && res.body.url) {
        this.photosList.push({
          url: res.body.url
        });
      }
    },
    removePhoto: function removePhoto(index) {
      this.photosList.splice(index, 1);
    },
    handleEditClose: function handleEditClose() {
      this.editDialogVisible = false;
      this.editForm.outerLinkId = null;
      this.editForm.shopAddress = '';
      this.editForm.wechatQrUrl = '';
      this.photosList = [];
    },
    // 保存编辑（仅更新二维码/门店照片/门店地址，小程序列表展示同源数据自动更新）
    saveEdit: function saveEdit() {
      var _this5 = this;
      var photos = [];
      this.photosList.forEach(function (item) {
        photos.push({
          url: item.url
        });
      });
      var par = {
        outerLinkId: this.editForm.outerLinkId,
        wechatQrUrl: this.editForm.wechatQrUrl,
        shopImages: photos.length > 0 ? JSON.stringify(photos) : '',
        shopAddress: this.editForm.shopAddress
      };
      api.UPDATE_MATCHMAKEROUTERLINK(par).then(function () {
        _this5.$message.success('操作成功');
        _this5.handleEditClose();
        _this5.initTableData();
      }).catch(function () {
        _this5.$message.error('保存失败');
      });
    },
    reset: function reset() {
      this.pageNo = 1;
      this.selectForm.selectCitys = [];
      this.selectForm.keyword = null;
      this.initTableData();
    },
    search: function search() {
      this.pageNo = 1;
      this.initTableData();
    },
    initTableData: function initTableData() {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var par, res;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              par = {
                pageNo: _this6.pageNo,
                pageSize: _this6.pageSize,
                keyword: _this6.selectForm.keyword
              };
              if (_this6.selectForm.selectCitys && _this6.selectForm.selectCitys.length > 0) {
                par.province = _this6.selectForm.selectCitys[0];
                if (_this6.selectForm.selectCitys.length > 1) {
                  par.city = _this6.selectForm.selectCitys[1];
                }
                if (_this6.selectForm.selectCitys.length > 2) {
                  par.area = _this6.selectForm.selectCitys[2];
                }
              }
              _context4.n = 1;
              return api.GET_MATCHMAKEROUTERLINK_PAGE_LIST(par);
            case 1:
              res = _context4.v;
              _this6.tableData = res.body.datas;
              _this6.pageTotal = res.body.sumDataCount;
            case 2:
              return _context4.a(2);
          }
        }, _callee4);
      }))();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      this.initTableData();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.pageNo = val;
      this.initTableData();
    }
  },
  created: function created() {
    this.initCitys();
    this.initTableData();
  }
};